/**
 * Deriv WebSocket error codes that must not trigger an automatic reconnect.
 *
 * These indicate the token / OTP URL itself is invalid or expired, so
 * reconnecting with the same credentials would loop forever. The caller is
 * responsible for obtaining fresh credentials (e.g. a new OTP URL via
 * `POST /trading/v1/options/accounts/{accountId}/otp`) before retrying.
 *
 * - `InvalidToken`    — v3 legacy token is invalid or expired.
 * - `AccountInvalid`  — the account associated with the token does not exist.
 * - `Unauthorized`    — v4 OTP connection rejected; OTP has expired or
 *                       the Bearer token used to generate it is no longer valid.
 */
export const PERMANENT_AUTH_ERROR_CODES = Object.freeze([
  'InvalidToken',
  'AccountInvalid',
  'Unauthorized',
]);

export const isPermanentAuthErrorCode = (code) =>
  PERMANENT_AUTH_ERROR_CODES.includes(code);
